<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
            <i class="fa fa-id-badge text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Vendedores</h4>
            <p class="text-muted mb-0 small">Gestão de equipe de vendas</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3">
            <!-- Search Pill -->
            <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <b-form-input type="text" ref="nome" v-model="nome" placeholder="Buscar por nome..." class="border-0 bg-transparent" style="width: 200px" @keydown.enter.native="pesquisar()" />
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> FILTRAR
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-2"></i>
              <span>Novo Vendedor</span>
            </b-button>
        </div>
      </div>

      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0">
        <b-col sm="12" class="p-0">
          <b-table ref="tbl" 
                  id="table-transition-example"        
                  class="modern-premium-table"
                  :dark="isDark"
                  primary-key="CODIGO"
                  responsive  hover  small  show-empty
                  empty-text="Informe o filtro para ver os registros "
                  :busy.sync="isBusy" 
                  :sticky-header="stickyHeight"
                  :tbody-tr-class="rowClassSelecionado"
                  :items="itensFiltrados" 
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @row-clicked="selecionarLinha"
                  @row-dblclicked="edit"
                  >
            <template #head(ID)>
              <SetFilter
                label="ID"
                v-model="filtros.ID"
                :options="opcoes.ID"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>      
            <template #head(NOME)>
              <SetFilter
                label="Nome"
                v-model="filtros.NOME"
                :options="opcoes.NOME"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(FIZ_JUR)>
              <SetFilter
                label="Tipo Pessoa"
                v-model="filtros.FIZ_JUR"
                :options="opcoes.FIZ_JUR"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(TIPO_CONTRATO)>
              <SetFilter
                label="Tipo Contrato"
                v-model="filtros.TIPO_CONTRATO"
                :options="opcoes.TIPO_CONTRATO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(STATUS)>
              <SetFilter
                label="Situação"
                v-model="filtros.STATUS"
                :options="opcoes.STATUS"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
                
            <template #cell(ID)="item">{{item.item.ID}}</template>
            <template #cell(NOME)="item">{{item.item.NOME}}</template>
            <template #cell(FIZ_JUR)="item">{{traduzirTipoPessoa(item.item)}}</template>
            <template #cell(TIPO_CONTRATO)="item">{{traduzirTipoContrato(item.item)}}</template>
            <template #cell(CPF)="item">{{formatarDocumento(item.item.CPF)}}</template>
            <template #cell(STATUS)="item">
              <b-badge  :variant="colorirStatus(item.item)">{{traduzirSituacao(item.item)}}</b-badge>
            </template>
            <template #cell(actions)="item">
              <div class="d-flex justify-content-end gap-1">
                <b-button type="button" @click.stop.prevent="edit(item.item)" variant="soft-primary" pill class="btn-icon-only shadow-sm" title="Editar" v-b-tooltip.hover>
                  <i class="fa fa-pencil"></i>
                </b-button>
                <b-button type="button" @click.stop.prevent="details(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Excluir" v-b-tooltip.hover>
                  <i class="fa fa-trash"></i>
                </b-button>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
      
      <!-- Modal de Confirmação para Resultado Grande -->
      <b-modal ref="modalConfirmacao" 
               hide-header
               hide-footer
               centered
               body-class="p-0 overflow-hidden"
               content-class="border-0 shadow-lg"
               @shown="onModalShown"
               @hidden="onModalHidden">
        
        <div class="modal-header-premium p-3 d-flex align-items-center bg-warning">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-exclamation-triangle text-dark"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-dark">Muitos Registros</h5>
                <small class="text-dark opacity-75">A pesquisa retornou um volume alto de dados</small>
            </div>
            <b-button variant="link" class="ml-auto text-dark p-0 opacity-75" @click="cancelarCarregarResultadoGrande">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white text-center">
            <div class="mb-4">
                <h1 class="display-4 font-weight-bold text-warning">{{ resultadoPendenteCount }}</h1>
                <p class="text-muted">Registros encontrados</p>
            </div>
            
            <p class="text-dark mb-4">
                Deseja carregar todos os registros? Isso pode afetar o desempenho da aplicação.
            </p>

            <div class="d-flex justify-content-center gap-3">
                <b-button variant="outline-secondary" pill class="px-4" @click="cancelarCarregarResultadoGrande">
                    <i class="fa fa-ban mr-1"></i> CANCELAR
                </b-button>
                <b-button variant="warning" pill class="px-4 font-weight-bold" @click="confirmarCarregarResultadoGrande">
                    <i class="fa fa-check mr-1"></i> SIM, CARREGAR
                </b-button>
            </div>
            <div class="mt-3">
                <small class="text-muted">Pressione [ESC] para cancelar</small>
            </div>
        </div>
      </b-modal>
      
    </div>  
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML'

export default {
  components: {
    SetFilter
  },

  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    preferVh: 65,
    useExternalPaging: true,
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'NOME', type: 'string', label: 'Nome' },
      { key: 'FIZ_JUR', type: 'string', label: 'Tipo Pessoa', labelMap: { '0': 'FÍSICA', '1': 'JURÍDICA' } },
      { key: 'TIPO_CONTRATO', type: 'string', label: 'Tipo Contrato', labelMap: { '0': 'VENDEDOR CONTRATADO', '1': 'VENDEDOR REPRESENTANTE' } },
      { key: 'CPF', type: 'string', label: 'Documento' },
      { key: 'STATUS',   type: 'string', label: 'Situação',
        labelMap: { '1': 'ATIVO', '2': 'INATIVO' } }
    ]
  })],
  data () {
    return {
      isLoading: false,
      status: '',
      isBusy: false,
      fields: [
        { key: "CODIGO", label: 'Id', sortable: true,  class:'align-middle text-right', thStyle: { width: "10%" }},
        { key: "NOME", label: 'Nome', sortable: true, class:'align-middle', thStyle: { width: "30%" }},
        { key: "FIZ_JUR", label: 'Tipo Pessoa', sortable: true, class:'align-middle text-center', thStyle: { width: "12%" }},
        { key: "TIPO_CONTRATO", label: 'Tipo Contrato', sortable: true, class:'align-middle text-center', thStyle: { width: "18%" }},
        { key: "CPF", label: 'Documento', sortable: true, class:'align-middle text-center', thStyle: { width: "15%" }},
        { key: "STATUS", label: 'Situação', sortable: true, class:'align-middle text-center', thStyle: { width: "10%" }},
        { key: "actions", label: 'Ações', class:'align-middle text-center p-0', thStyle: { width: "5%" }}
      ],
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      modalConfirmacaoAberto: false,
    }
  },
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    id: {
      get () {
        return this.$store.getters['vendedor/ID']
      }, 
      set (value) {
        this.$store.commit("vendedor/SET_ID", value);
      }
    },
    nome: {
      get () {
        return this.$store.getters['vendedor/NOME']
      }, 
      set (value) {
        this.$store.commit("vendedor/SET_NOME", value);
      }
    },
    perPage: {
      get () {
        return this.$store.getters['vendedor/PER_PAGE']
      }, 
      set (value) {
        this.$store.commit("vendedor/SET_PER_PAGE", value);
      }
    },
    currentPage: {
      get () {
        return this.$store.getters['vendedor/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("vendedor/SET_PAGINA_ATUAL", value);
      }
    },
    lista: {
      get () {
        return this.$store.getters['vendedor/LISTA']
      }, 
      set (value) {
        this.$store.commit("vendedor/SET_LISTA", value);
      }
    },/*
    lista() {
      return this.$store.getters['cliente/LISTA']
    }*/
  },
  methods: {
    selecionarLinha(item) {
      this.$store.commit("vendedor/SET_REGISTRO_SELECIONADO_ID", item.CODIGO)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['vendedor/REGISTRO_SELECIONADO_ID']
      return item.CODIGO === selId ? 'cec-row-selected' : ''
    },
    colorirStatus(linha) { 
      if (linha.STATUS == '0') return 'danger'
      else return 'success'
    },
    traduzirSituacao(linha) { 
      if (linha.STATUS == '0') return 'INATIVO'
      else return 'ATIVO'
    },
    traduzirTipoPessoa(linha) {
      const mapa = {
        '0': 'Física',
        '1': 'Jurídica'
      }

      return mapa[String(linha.FIZ_JUR)] || '-'
    },
    traduzirTipoContrato(linha) {
      const mapa = {
        '0': 'Vendedor Contratado',
        '1': 'Vendedor Representante'
      }

      return mapa[String(linha.TIPO_CONTRATO)] || '-'
    },
    formatarDocumento(valor) {
      const numeros = (valor || '').toString().replace(/\D/g, '')

      if (numeros.length === 11) {
        return numeros.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4')
      }

      if (numeros.length === 14) {
        return numeros.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
      }

      return numeros || '-'
    },
    limparFiltro() {
      this.nome = null
      this.cpf = null
      this.id = null
      this.lista = []
    },
    edit (item) {
      this.$router.push(`/cadastros/vendedor/edit/${item.CODIGO}`)
    },
    novo () {
      this.$router.push(`/cadastros/vendedor/add`)
    },
    async pesquisar (ctx) {
      // Impede pesquisa se o modal está aberto
      if (this.modalConfirmacaoAberto) {
        return
      }
      
      try {
        this.isLoading = true
        this.isBusy = true
        
        // Remove o foco do input antes de abrir modal
        const inputElement = this.$refs.nome
        if (inputElement && inputElement.$el) {
          inputElement.$el.blur()
        } else if (inputElement) {
          inputElement.blur()
        }
        
        const result = await this.$store.dispatch('vendedor/GERAR_LISTA')
        
        // Verifica se precisa de confirmação
        if (result.needsConfirmation) {
          this.resultadoPendente = result.data
          this.resultadoPendenteCount = result.count
          this.$refs.modalConfirmacao.show()
          return
        }
        
      } catch (err) {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Operação não permitida!')
      } finally {
        this.isBusy = false
        this.isLoading = false
        this.status = true // or success
      }
    },
    confirmarCarregarResultadoGrande() {
      // Fecha o modal
      this.$refs.modalConfirmacao.hide()
      
      // Carrega os dados pendentes
      if (this.resultadoPendente) {
        this.$store.commit('vendedor/SET_LISTA', this.resultadoPendente)
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
      }
    },
    cancelarCarregarResultadoGrande() {
      // Apenas fecha o modal e limpa os dados pendentes
      this.$refs.modalConfirmacao.hide()
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
    },
    onModalShown() {
      this.modalConfirmacaoAberto = true
    },
    onModalHidden() {
      this.modalConfirmacaoAberto = false
    },
    exportarHtml() {
      printHtmlReport({
        rows: this.itensFiltrados,
        reportTitle: 'Listagem de Vendedores',
        printedBy: window.localStorage.getItem('login') ?? '—',
        columns: this.fields.filter(f => f.key !== 'actions'),
        filename: 'vendedores.html',
      });
    },
    exportarExcel() {
      exportExcelXlsx({
        rows: this.itensFiltrados,
        columns: this.fields.filter(f => f.key !== 'actions'),
        filename: 'vendedores.xlsx',
      });
    },
    exportarCsv() {
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.fields.filter(f => f.key !== 'actions'),
        filename: 'vendedores.csv',
      });
    }
  },
  async created() {
    const listagem = this.$store.getters['vendedor/LISTA']
    if (!listagem.length) {
      await this.pesquisar()
    }
  }
}
</script>
<style >
</style>



// WEBPACK FOOTER //
// src/views/cadastros/vendedor/VendedorListagem.vue